import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getFeature } from "@Libs/FeatureFlags/services/features";
import {
  IPaymentPlan,
  ISubscriptionsFeature,
} from "../services/subscriptionsFeature";
import { ISubscriptionPlan } from "../types";

export const SUBSCRIPTION_PLAN_CMS_NAMES: {
  [key in ISubscriptionPlan["name"]]: IPaymentPlan["name"];
} = {
  monthly_subscription: "Monthly",
  quarterly_subscription: "Quarterly",
  yearly_subscription: "Yearly",
};

export const useSubscriptionsFeature = () => {
  const {
    data: subscriptionsFeature,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<ISubscriptionsFeature>("subscriptionsFeature", () =>
    getFeature<ISubscriptionsFeature>("subscriptions").then(({ data }) => data)
  );

  const getPlanContent = (plan: ISubscriptionPlan) =>
    subscriptionsFeature?.details.clientSubscription.paymentPlans.find(
      (paymentPlan) =>
        paymentPlan.name === SUBSCRIPTION_PLAN_CMS_NAMES[plan.name]
    );

  return {
    subscriptionsFeature,
    isLoading,
    isError,
    isSuccess,
    status,
    getPlanContent,
  };
};
